<template>
  <div style="padding: 20px 20px">
    <ScanQuery @onQuery="add" ph="请填入批次包编号" keyText="添加">
      <div style="font-size: 16px; font-weight: bold">
        调拨单编号：{{ transferWarehouseCode }}
      </div>
      <el-button type="primary" :disabled="true" style="margin-left: 10px">
        当前绑定数量:{{ totalAmount || 0 }}</el-button>
      <div slot="customize" class="searchdiv">
        <el-input maxlength='450' v-model="logisticsNo" placeholder="回填物流单号" style="margin-right: 10px"></el-input>
        <el-button type="primary" @click="onSubmit"> 提交 </el-button>
      </div>
    </ScanQuery>

    <el-table :data="dataSource" style="width: 100%; margin-top: 20px" :border="true" size="medium">
      <el-table-column label="批次单编号" prop="pkgCode"> </el-table-column>
      <el-table-column label="数量" prop="amount"> </el-table-column>
      <el-table-column label="操作" prop="logisticsCode">
        <template slot-scope="record">
          <i class="el-icon-circle-close" @click="del(record.$index)"></i>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import ScanQuery from "@/components/ScanQuery";
import { getPkg, createDelivery } from "@/apis/outDomestic";
export default {
  name: "addPkg",
  components: {
    ScanQuery,
  },
  data() {
    return {
      pkgCode: "",
      query: {
        code: "",
      },
      logisticsNo: "",
      transferWarehouseCode: "",
      customerShopId: '',
      dataSource: [],
      pkgList: [],
      totalAmount: 0,
    };
  },
  watch: {
    "$route.params": {
      immediate: true,
      handler: function (newVal) {
        if (newVal.transferWarehouseCode) {
          this.initPage();
          this.transferWarehouseCode = newVal.transferWarehouseCode;
          this.customerShopId = newVal.customerShopId
        }
      },
    },
    dataSource: {
      immediate: true,
      handler: function (newVal) {
        if (newVal) {
          let amount = 0
          this.dataSource.forEach((item) => {
            amount += item.amount;
          });
          this.totalAmount = amount
        }
      },
    },
  },
  // computed: {
  //   totalAmount: function () {
  //     let amount = 0
  //     this.dataSource.forEach((item) => {
  //       console.log('dataSource', this.dataSource)
  //       amount += item.amount;
  //     });
  //     return amount
  //   }
  // },
  mounted() {
    if (!this.$route.params.transferWarehouseCode) {
      this.$router.push({ path: "/outOfDomestic_domesticShipment" });
    }
  },
  methods: {
    add: function (payload) {
      if (!payload.code) {
        this.$message.warning('请填入批次包编号')
        return false;
      }
      if (this.pkgList.includes(payload.code)) {
        this.$message.warning('重复添加')
        return false;
      }
      let params = {
        pkgCode: payload.code,
        customerShopId: this.customerShopId
      };
      getPkg(params).then(({ code, data }) => {
        if (code === 0) {
          this.dataSource.push(data);
          this.pkgList.push(payload.code)
        }
        // this.dataSource.forEach((item) => {
        //   this.totalAmount += item.amount;
        // });
      });
    },
    onSubmit: function () {
      if (!this.logisticsNo) {
        this.$message.warning("请填写物流单号");
        return;
      }
      if (this.dataSource.length == 0) {
        this.$message.warning("请添加批次包");
        return;
      }
      let params = {
        logisticsNo: this.logisticsNo,
        transferWarehouseCode: this.transferWarehouseCode,
        pkgList: this.dataSource,
      };
      createDelivery(params).then(({ code, data }) => {
        if (code === 0) {
          this.$message.success("成功");
          this.initPage();
        }
      });
    },
    del: function (index) {
      this.dataSource.splice(index, 1);
    },
    initPage() {
      this.pkgCode = "";
      this.query = {
        code: "",
      };
      this.logisticsNo = "";
      this.dataSource = [];
      this.totalAmount = 0;
    },
  },
};
</script>

<style>
.searchdiv {
  display: flex;
  align-items: center;
}
</style>
